export default __webpack_public_path__ + "static/media/SF-SiteName.50ad1e15.png";